import { Fragment } from 'react';
import './App.css';
import WebRoutes from './Routing/WebRoutes';


function App() {
  return (
    <Fragment>
      <WebRoutes />
    </Fragment>
  );
}

export default App;
